<template>
  <div class="phdp">
    <div class="phdp__map">
      <map-component :points="points" :key="mapKey" @pointClick="pointClick">
      </map-component>
      <div class="phdp__lieanr"></div>
      <layout-header class="phdp__top"></layout-header>
      <div class="phdp__left">
        <base-card height="240px" width="467px">
          <div slot="header">{{ $t("bigScreen.在线设备数") }}</div>
          <div slot="content">
            <base-loading :loading="loadingPie" background="transparent">
              <echarts-pie
                :data="pieData"
                :zxs="zxs"
                height="160px"
                width="100%"
              ></echarts-pie>
            </base-loading>
          </div>
        </base-card>
        <base-card class="mrt-20" height="704px" width="467px">
          <div slot="header">{{ $t("bigScreen.切割统计") }}</div>
          <div slot="content">
            <base-loading :loading="loadingLine" background="transparent">
              <echarts-line
                v-if="xData.length > 0"
                :xData="xData"
                :y1Data="yData1"
                :y2Data="yData2"
                :series="series"
                :y1Name="$t('bigScreen.耗线量') + '(km)'"
                :y2Name="
                  $t('bigScreen.荒料量') + '(' + $t('bigScreen.个') + ')'
                "
                height="300px"
              ></echarts-line>
              <base-empty v-else></base-empty>
            </base-loading>
            <base-loading :loading="loadingSraingle" background="transparent">
              <echarts-traingle
                v-if="xData.length > 0"
                :xData="xData"
                :yData="yData3"
                :series="series1"
                :yName="
                  $t('bigScreen.单位') + '(' + $t('bigScreen.万') + ' ㎡)'
                "
                class="mrt-40"
                height="230px"
              ></echarts-traingle>
              <base-empty v-else></base-empty>
            </base-loading>
          </div>
        </base-card>
      </div>
      <div class="phdp__center">
        <base-card
          height="315px"
          :more="true"
          :showButton="showOrNot"
          @onMore="clickMore1"
          @onAll="showAll"
        >
          <div slot="header">{{ $t("bigScreen.在线设备列表") }}</div>
          <div slot="content">
            <base-loading :loading="loadingTable" background="transparent">
              <div class="table">
                <el-table
                  stripe
                  ref="elTable"
                  :data="zxsbDataList"
                  style="width: 100%"
                  :cell-style="cellStyle"
                  @row-click="toDetail"
                >
                  <template slot="empty">
                    <base-empty
                      :size="130"
                      :description="$t('bigScreen.暂无数据')"
                    ></base-empty>
                  </template>
                  <el-table-column
                    :index="indexMethod"
                    type="index"
                    :label="$t('bigScreen.序号')"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="qymc"
                    show-overflow-tooltip
                    :label="$t('bigScreen.客户名称')"
                  >
                  </el-table-column>
                  <el-table-column prop="sbgk" :label="$t('bigScreen.型号')">
                  </el-table-column>
                  <el-table-column
                    prop="sbmc"
                    :label="$t('bigScreen.设备名称')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="gzztmc"
                    :label="$t('bigScreen.工作状态')"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        scope.row.gzztmc
                          ? $t("detailScreen." + scope.row.gzztmc)
                          : ""
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    :label="$t('bigScreen.更新时间')"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </base-loading>
          </div>
        </base-card>
      </div>
      <div class="phdp__right">
        <base-card height="604px">
          <div slot="header">{{ $t("bigScreen.实时切割视频") }}</div>
          <div slot="content">
            <ezviz-video
              :deviceSerial="ssjkspList[0] ? ssjkspList[0].jkxlh : ''"
              :width="427"
              :height="240"
            ></ezviz-video>
            <div style="display: flex">
              <ezviz-video
                :deviceSerial="ssjkspList[1] ? ssjkspList[1].jkxlh : ''"
                :width="207"
                :height="116"
              ></ezviz-video>
              <ezviz-video
                style="margin-left: 13px"
                :deviceSerial="ssjkspList[2] ? ssjkspList[2].jkxlh : ''"
                :width="207"
                :height="116"
              ></ezviz-video>
            </div>
            <div style="display: flex">
              <ezviz-video
                :deviceSerial="ssjkspList[3] ? ssjkspList[3].jkxlh : ''"
                :width="207"
                :height="116"
              ></ezviz-video>
              <ezviz-video
                style="margin-left: 13px"
                :deviceSerial="ssjkspList[4] ? ssjkspList[4].jkxlh : ''"
                :width="207"
                :height="116"
              ></ezviz-video>
            </div>
          </div>
        </base-card>
        <base-card
          class="mrt-20"
          height="340px"
          :more="true"
          @onMore="clickMore"
        >
          <div slot="header">{{ $t("bigScreen.报警统计") }}</div>
          <div slot="content">
            <el-date-picker
              class="m-picker"
              :clearable="false"
              v-model="daterange"
              type="daterange"
              @change="timeChange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <base-loading :loading="loadingBarBattery">
              <echarts-bar-battery
                v-if="bjXData.length > 0"
                :yData="bjYData"
                :data="bjXData"
                width="100%"
                height="300px"
              ></echarts-bar-battery>
              <base-empty v-else></base-empty>
            </base-loading>
          </div>
        </base-card>
      </div>
    </div>
    <bjtj-dialog
      v-if="showDialog"
      :showDiaolog="showDialog"
      @close="showDialog = !showDialog"
    ></bjtj-dialog>
    <zxsb-dialog
      v-if="showDialog1"
      :showDiaolog="showDialog1"
      @close="showDialog1 = !showDialog1"
    ></zxsb-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import EchartsLine from "@/components/echarts-line/index";
import EchartsTraingle from "@/components/echarts-traingle/index";
import EchartsBarBattery from "@/components/echarts-bar-battery/index";

import EzvizVideo from "@/views/ezviz-video/index";
import BjtjDialog from "@/views/bjtj-dialog/index.vue";
import ZxsbDialog from "@/views/zxsb-dialog/index.vue";
import {
  getZxsbs,
  getNdQgtj,
  getZxsblb,
  getSsqgsplb,
  getBjjltj,
  getSbtj,
} from "@/api/dpIndex";
import MapComponent from "@/components/map-component/index";
import LayoutHeader from "@/views/layout-header/index";
import { Message } from "element-ui";

export default {
  name: "phdp-index",
  components: {
    MapComponent,
    ZxsbDialog,
    BjtjDialog,
    EzvizVideo,
    EchartsBarBattery,
    EchartsTraingle,
    EchartsLine,
    LayoutHeader,
  },
  data() {
    return {
      mapKey: 0,
      showDialog: false,
      showDialog1: false,
      nowYear: "",
      zxs: 0,
      daterange: [],
      loadingPie: false,
      loadingLine: false,
      loadingSraingle: false,
      loadingTable: false,
      loadingBarBattery: false,
      pieData: [
        {
          name: this.$t("bigScreen.正常设备"),
          value: 0,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: "rgba(88, 255, 251, 1)" },
              { offset: 1, color: "rgba(44, 255, 195, 1)" },
            ]),
          },
        },
        {
          name: "异常设备",
          value: 0,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: "rgba(252, 255, 87, 1)" },
              { offset: 1, color: "rgba(255, 147, 84, 1)" },
            ]),
          },
        },
      ],
      series: [],
      series1: [],
      xData: [],
      yData1: [],
      yData2: [],
      yData3: [],
      bjXData: [],
      bjYData: [],
      zxsbDataList: [],
      ssjkspList: [],
      points: [],
      timer: null,
      showOrNot: false,
      pointMessage: null,
    };
  },
  created() {
    this.getNowMonth();
    this.getNowYear();
    this.getSsqgsplb();
    this.getSbtj();
    this.init();
    this.startTimer();

    // 监听语言变化
    this.$root.$on("languageChanged", () => {
      this.init();
      this.startTimer();
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    // 移除事件监听
    this.$root.$off("languageChanged");
  },
  methods: {
    init() {
      this.getZxsbs();
      this.getNdQgtj();
      this.getZxsblb();
      this.getBjjltj();
    },
    init2() {
      this.getZxsbs2();
      this.getNdQgtj2();
      this.getZxsblb2();
      this.getBjjltj2();
    },
    cellStyle() {
      return "cursor:pointer;";
    },
    indexMethod(index) {
      return index + 1;
    },
    toDetail(data) {
      if (data.gzztdm === "") {
        Message.error(this.$t("detailScreen.该设备异常"));
        return;
      }
      this.$router.push({
        path: "/detail",
        query: {
          sbxxid: data.sbxxid,
        },
      });
    },
    getNowMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let monthFirstday = year + "-" + month + "-1";
      let nowDate = year + "-" + month + "-" + day;
      this.daterange = [monthFirstday, nowDate];
    },
    getNowYear() {
      let date = new Date();
      this.nowYear = date.getFullYear();
    },
    timeChange() {
      this.getBjjltj();
    },
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.init2, 15000);
    },
    async getZxsbs() {
      this.pieData = [];
      this.loadingPie = true;
      let params = {
        token: this.$store.state.user.token,
      };
      getZxsbs(params).then((result) => {
        this.zxs = result.data.zxs || 0;
        // this.zxs = Number(result.data.ycs) + 35;
        this.pieData = [
          {
            name: "正常设备",
            value: result.data.zcs || 0,
            // value: 35,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: "rgba(88, 255, 251, 1)" },
                { offset: 1, color: "rgba(44, 255, 195, 1)" },
              ]),
            },
          },
          {
            name: "异常设备",
            value: result.data.ycs || 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: "rgba(252, 255, 87, 1)" },
                { offset: 1, color: "rgba(255, 147, 84, 1)" },
              ]),
            },
          },
        ];
        this.loadingPie = false;
      });
    },
    async getZxsbs2() {
      let params = {
        token: this.$store.state.user.token,
      };
      getZxsbs(params).then((result) => {
        this.pieData = [];
        this.zxs = result.data.zxs || 0;
        // this.zxs = Number(result.data.ycs) + 35;
        this.pieData = [
          {
            name: "正常设备",
            value: result.data.zcs || 0,
            // value: 35,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: "rgba(88, 255, 251, 1)" },
                { offset: 1, color: "rgba(44, 255, 195, 1)" },
              ]),
            },
          },
          {
            name: "异常设备",
            value: result.data.ycs || 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: "rgba(252, 255, 87, 1)" },
                { offset: 1, color: "rgba(255, 147, 84, 1)" },
              ]),
            },
          },
        ];
      });
    },
    async getNdQgtj() {
      this.loadingLine = true;
      this.loadingSraingle = true;
      this.series = [];
      this.series1 = [];
      this.xData = [];
      this.yData1 = [];
      this.yData2 = [];
      this.yData3 = [];

      let params = {
        token: this.$store.state.user.token,
      };

      getNdQgtj(params).then((result) => {
        result.data.forEach((item) => {
          let qghxl = (Number(item.qghll) * 6.5).toFixed(2);
          this.xData.push(this.formatMonth(item.rq));
          // this.yData1.push((Number(item.qghxl) / 1000).toFixed(2));
          this.yData1.push(qghxl);
          this.yData2.push(item.qghll);
          this.yData3.push((Number(item.qgpfs) / 10000).toFixed(2));
        });
        this.series = [
          {
            name: this.$t("bigScreen.切割耗线量"),
            type: "line",
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255, 227, 29, 0.50)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 243, 61, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(27, 136, 255, 0)",
                shadowBlur: 20,
              },
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + "km";
              },
            },
            data: this.yData1,
          },
          {
            name: this.$t("bigScreen.切割荒料量"),
            yAxisIndex: 1,
            type: "line",
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(104, 232, 255, 0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(55, 204, 253, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(27, 136, 255, 0)",
                shadowBlur: 20,
              },
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + " " + this.$t("bigScreen.个");
              },
            },
            data: this.yData2,
          },
        ];

        this.series1 = [
          {
            name: this.$t("bigScreen.切割平方数"),
            type: "pictorialBar",
            barCategoryGap: "5%",
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              normal: {
                //渐变色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(104, 232, 255, 1)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(65, 210, 253, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(55, 204, 253, 0)",
                  },
                ]),
              },
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + " " + this.$t("bigScreen.万") + "m²";
              },
            },
            data: this.yData3,
            z: 10,
          },
        ];

        this.loadingLine = false;
        this.loadingSraingle = false;
      });
    },
    async getNdQgtj2() {
      let params = {
        nd: this.nowYear,
        token: this.$store.state.user.token,
      };
      getNdQgtj(params).then((result) => {
        this.series = [];
        this.series1 = [];
        this.xData = [];
        this.yData1 = [];
        this.yData2 = [];
        this.yData3 = [];
        result.data.forEach((item) => {
          let qghxl = (Number(item.qghll) * 6.5).toFixed(2);
          this.xData.push(this.formatMonth(item.rq));
          // this.yData1.push((Number(item.qghxl) / 1000).toFixed(2));
          this.yData1.push(qghxl);
          this.yData2.push(item.qghll);
          this.yData3.push((Number(item.qgpfs) / 10000).toFixed(2));
        });
        this.series = [
          {
            name: this.$t("bigScreen.切割耗线量"),
            type: "line",
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255, 227, 29, 0.50)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 243, 61, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(27, 136, 255, 0)",
                shadowBlur: 20,
              },
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + "km";
              },
            },
            data: this.yData1,
          },
          {
            name: this.$t("bigScreen.切割荒料量"),
            yAxisIndex: 1, //与 y2轴绑定
            type: "line",
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(104, 232, 255, 0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(55, 204, 253, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(27, 136, 255, 0)",
                shadowBlur: 20,
              },
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + " " + this.$t("bigScreen.个");
              },
            },
            data: this.yData2,
          },
        ];
        let legendName = this.$t("bigScreen.切割平方数");
        this.series1 = [
          {
            name: legendName,
            type: "pictorialBar",
            barCategoryGap: "5%",
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              normal: {
                //渐变色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(104, 232, 255, 1)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(65, 210, 253, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(55, 204, 253, 0)",
                  },
                ]),
              },
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + " " + this.$t("bigScreen.万") + "m²";
              },
            },
            data: this.yData3,
            z: 10,
          },
        ];
      });
    },
    async getZxsblb() {
      this.loadingTable = true;
      this.zxsbDataList = [];
      let params = {
        token: this.$store.state.user.token,
        gzztgl: "1",
        pageNum: "1",
        pageSize: "4",
        gsxxid: this.pointMessage,
      };
      getZxsblb(params).then((result) => {
        this.zxsbDataList = result.rows;
        this.loadingTable = false;
      });
    },
    async getZxsblb2() {
      // this.loadingTable = true;
      let params = {
        token: this.$store.state.user.token,
        gzztgl: "1",
        pageNum: "1",
        pageSize: "4",
        gsxxid: this.pointMessage,
      };
      getZxsblb(params).then((result) => {
        this.zxsbDataList = [];
        this.zxsbDataList = result.rows;
        // this.loadingTable = false;
      });
    },
    async getSsqgsplb() {
      this.ssjkspList = [];
      let params = {
        token: this.$store.state.user.token,
        sfdpxs: "Y",
      };
      getSsqgsplb(params).then((result) => {
        this.ssjkspList = result.rows;
      });
    },
    async getBjjltj() {
      this.loadingBarBattery = true;
      this.bjXData = [];
      this.bjYData = [];
      let params = {
        token: this.$store.state.user.token,
        startDate: this.daterange ? this.daterange[0] : "",
        endDate: this.daterange ? this.daterange[1] : "",
        pageNum: 1,
        pageSize: 5,
      };
      getBjjltj(params).then((result) => {
        result.rows.forEach((item) => {
          this.bjXData.push(item.sl);
          this.bjYData.push(item.bjlxmc);
        });
        this.loadingBarBattery = false;
      });
    },
    async getBjjltj2() {
      // this.loadingBarBattery = true;
      let params = {
        token: this.$store.state.user.token,
        startDate: this.daterange ? this.daterange[0] : "",
        endDate: this.daterange ? this.daterange[1] : "",
        pageNum: 1,
        pageSize: 5,
      };
      getBjjltj(params).then((result) => {
        this.bjXData = [];
        this.bjYData = [];
        result.rows.forEach((item) => {
          this.bjXData.push(item.sl);
          this.bjYData.push(item.bjlxmc);
        });
        // this.loadingBarBattery = false;
      });
    },
    async getSbtj() {
      this.points = [];
      let params = {
        token: this.$store.state.user.token,
      };
      getSbtj(params).then((result) => {
        this.mapKey++;
        this.points = result.data;
      });
    },
    clickMore() {
      this.showDialog = true;
    },
    clickMore1() {
      this.showDialog1 = true;
    },
    showAll() {
      this.showOrNot = false;
      this.pointMessage = null;
      this.getZxsblb();
    },
    pointClick(e) {
      this.showOrNot = true;
      this.pointMessage = e.gsxxid;
      this.getZxsblb();
    },
    formatMonth(date) {
      const monthMap = {
        "01": "一月",
        "02": "二月",
        "03": "三月",
        "04": "四月",
        "05": "五月",
        "06": "六月",
        "07": "七月",
        "08": "八月",
        "09": "九月",
        10: "十月",
        11: "十一月",
        12: "十二月",
        // 处理没有前导零的情况
        1: "一月",
        2: "二月",
        3: "三月",
        4: "四月",
        5: "五月",
        6: "六月",
        7: "七月",
        8: "八月",
        9: "九月",
      };

      let month;
      if (date.includes("-")) {
        // 处理 YYYY-MM-DD 格式
        month = date.split("-")[1];
      } else if (date.includes("月")) {
        // 处理 "2月" 格式
        month = date.replace("月", "");
        // 补充前导零
        month = month.length === 1 ? "0" + month : month;
      } else {
        // 其他格式，直接使用数字
        month = date;
        // 补充前导零
        month = month.length === 1 ? "0" + month : month;
      }

      return this.$t(`bigScreen.${monthMap[month]}`);
    },
  },
};
</script>

<style lang="less" scoped>
.phdp {
  &__map {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  &__lieanr {
    width: 100%;
    height: 100px;
    background: linear-gradient(
      180deg,
      #020825 0%,
      rgba(3, 12, 52, 0.61) 57%,
      rgba(5, 19, 76, 0) 100%
    );
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  &__center {
    width: calc(98% - 974px);
    height: 100%;
    position: absolute;
    top: calc(100% - 336px);
  }

  &__left {
    width: 467px;
    height: 100%;
    position: absolute;
    left: 1%;
    top: calc(100% - 985px);
  }
  &__top {
    position: absolute;
    top: 0;
    img {
      height: 90px;
      width: 100%;
    }
  }

  &__right {
    width: 467px;
    height: 100%;
    position: absolute;
    right: 1%;
    top: calc(100% - 985px);
  }
}
.m-picker {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #68e8ff;
  background-color: transparent;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  border: 0.7px solid #3e8ca6 !important;
  //文本域占位字符颜色更改
  ::-webkit-input-placeholder {
    color: #68e8ff !important;
  }
  /deep/ .el-input__icon {
    color: #68e8ff !important;
  }
  /deep/ .el-range-input {
    background-color: transparent;
    color: #68e8ff !important;
  }
  /* 修改Element UI中日期选择器placeholder的颜色 */
  /deep/ .el-date-editor .el-input__placeholder {
    color: #68e8ff !important;
  }
  /deep/ .el-range-separator {
    color: #68e8ff !important;
  }
}

/deep/ .el-table {
  tbody tr:last-child td {
    border-bottom: 1px solid #0761a4;
  }
}
</style>
